module.exports = __webpack_public_path__ + "static/stitch-call-d1d9763de53d492a02837c8650ba51ab.png";